<ion-header>
  <ion-toolbar>
    <ion-title>{{'Providers' | translate}}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="close()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  
  <div class="content-width">

    <ion-accordion-group>

      <!-- Playsight -->
      <ion-accordion value="playsight">
        <ion-item slot="header" color="light">
          <ion-avatar slot="start">
            <img [src]="'assets/img/logo/playsight/avatar.png'" />
          </ion-avatar>
          <ion-label>{{'PlaySight' | translate}}</ion-label>
        </ion-item>

        <div class="ion-padding" slot="content">

          @if (!playsightCameras?.length) {
            @for (item of videoStreamProviderList; track $index) {
              @if (item?.partner?.username === 'playsight') {
                <app-view-cameras [isSelectable]="true" [videoStreamProvider]="item" (removeFacility)="removeFacility(item)"></app-view-cameras>
              }
            }
          }

          <app-manage-cameras
            [match]="match"
            [partner]="'playsight'"
            [cameras]="playsightCameras"
            (updateCameras)="getVideoStreamProviderList()">
          </app-manage-cameras>

          <ion-card class="ion-margin">
            <ion-card-content>
              {{'In order to show iOnCourt feed on PlaySight camera, select a camera or copy the link to PlaySight admin area. If you need more help reach out to PlaySight directly at support&#64;playsight.com.' | translate}} 
              <ion-item>
                <ion-textarea rows="1" [autoGrow]="true" readonly type="text" [value]="playsightLink"></ion-textarea>
                <ion-button color="primary" (click)="copyLink()" slot="end" fill="clear">
                  <ion-icon slot="icon-only" name="copy"></ion-icon>
                </ion-button>
              </ion-item>
            </ion-card-content>
          </ion-card>
          
          
        </div>
      </ion-accordion>

      <!-- Track.Tennis -->
      <ion-accordion value="tracktennis">
        <ion-item slot="header" color="light">
          <ion-avatar slot="start">
            <img [src]="'assets/img/logo/tracktennis/avatar.jpg'" />
          </ion-avatar>
          <ion-label>{{'Track.Tennis' | translate}}</ion-label>
        </ion-item>
        <div class="ion-padding" slot="content">

          @if (!tracktennisCameras?.length) {
            @for (item of videoStreamProviderList; track $index) {
              @if (item?.partner?.username === 'tracktennis') {
                <app-view-cameras [isSelectable]="true" [videoStreamProvider]="item" (removeFacility)="removeFacility(item)"></app-view-cameras>
              }
            }
          }

          <app-manage-cameras
            [match]="match"
            [partner]="'tracktennis'"
            [cameras]="tracktennisCameras"
            (updateCameras)="getVideoStreamProviderList()">
          </app-manage-cameras>
        </div>

      </ion-accordion>

        <!-- Save My Play -->
        <ion-accordion value="savemyplay">
          <ion-item slot="header" color="light">
            <ion-avatar slot="start">
              <img [src]="'assets/img/logo/savemyplay/avatar.png'" />
            </ion-avatar>
            <ion-label>{{'Save My Play' | translate}}</ion-label>
          </ion-item>
          <div class="ion-padding" slot="content">
  
            @if (!saveMyPlayCameras?.length) {
              @for (item of videoStreamProviderList; track $index) {
                @if (item?.partner?.username === 'savemyplay') {
                  <app-view-cameras [isSelectable]="true" [videoStreamProvider]="item" (removeFacility)="removeFacility(item)"></app-view-cameras>
                }
              }
            }
  
            <app-manage-cameras
              [match]="match"
              [partner]="'savemyplay'"
              [cameras]="saveMyPlayCameras"
              (updateCameras)="getVideoStreamProviderList()">
            </app-manage-cameras>
          </div>
  
        </ion-accordion>

      <!-- Microframe -->
      <ion-accordion value="microframe">
        <ion-item slot="header" color="light">
          <ion-avatar slot="start">
            <img [src]="'assets/img/logo/microframe/avatar.png'" />
          </ion-avatar>
          <ion-label>{{'Microframe' | translate}}</ion-label>
        </ion-item>
        <div class="ion-padding" slot="content">

          @if (!microframeCameras?.length) {
            @for (item of videoStreamProviderList; track $index) {
              @if (item?.partner?.username === 'microframe') {
                <app-view-cameras 
                  [isSelectable]="true" 
                  [videoStreamProvider]="item" 
                  (removeFacility)="removeFacility(item)">
                </app-view-cameras>
              }
            }
          }

          <app-manage-cameras
            [match]="match"
            [partner]="'microframe'"
            [cameras]="microframeCameras"
            (updateCameras)="getVideoStreamProviderList()">
          </app-manage-cameras>

        </div>
      </ion-accordion>
    </ion-accordion-group>
  </div>

</ion-content>